<template>
  <div>
    <el-dialog
      title="查看图片"
      :visible.sync="dialogVisible"
      v-dialogDrag
      width="400px"
      :modal="true"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div>
        <el-row>
          <el-col :span="24">
            <el-image :src="host + '/api' + url" style="width:100%;" :preview-src-list="[host + '/api' + url]"></el-image>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="del" type="danger" v-if="!readonly"  >删除图片</el-button>
        <el-button @click="dialogVisible = false"  >关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      dialogVisible: false,
      url: "",
    }
  },
  methods: {
    open(url) {
      this.url = url;
      this.dialogVisible = true;
    },
    del() {
      this.$confirm("确认删除图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("del");
          this.close();
        })
        .catch(() => {});
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col{
  margin: 10px 0px 0 0;
}
// .title{
//   font-size: 14px;
//   margin: 0px 20px 0 0;
// }
// .date{
//   margin: 5px 0 0 76px;
//   display: block;
// }
// /deep/ .el-dialog__body{
//   padding-top: 0;
//   padding-right: 10px;
// }
</style>